const routerView = {
  template: '<router-view></router-view>'
};
export default [
  {
    name: 'openMileConversationView',
    path: '',
    meta: {
      title: '오픈마일 대화 목록'
    },
    component: routerView,
    children: [
      {
        path: '/openmile/conversation-view',
        name: 'openMile_conversation_list',
        meta: {
          title: '오픈마일 대화 목록',
          requiresAuth: false
        },
        component: () => import(/* webpackChunkName: "OpenMileConverationView" */ '@/components/menus/conversationView/conversationViewList'), // 오픈마일 STT 완료 조회
        props: (route) => ({
          epn: route.query.epn
        })
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/subRoutes/conversationView.js